export const detectIsBrowser = () => typeof window !== 'undefined';
export const isBrowser = detectIsBrowser();
